"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMicroFrontendsByMountPoint = exports.hasMicroFrontend = exports.getAllMicroFrontends = exports.getMicroFrontends = exports.getMicroFrontend = void 0;
exports.isMicroFrontendVersion = isMicroFrontendVersion;
exports.isMicroFrontendDefinition = isMicroFrontendDefinition;
var environments_1 = require("../configs/environments");
var microFrontends_1 = require("../configs/microFrontends");
var microFrontends_2 = require("../types/microFrontends");
var sanitizeMicroFrontendId = function (id) {
    return id.replace(/[-_]/gm, '');
};
/**
 * Get the micro-frontend definition for the given name.
 * @param id
 * @param version
 */
// eslint-disable-next-line complexity
var getMicroFrontend = function (id, version) {
    var _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    if (version === void 0) { version = 'latest'; }
    var mfe = microFrontends_1.microFrontends[id];
    if (!mfe) {
        return undefined;
    }
    var sanitizedId = sanitizeMicroFrontendId(id);
    var packageName = mfe.packageName || "@iu/myiu.fe.app.".concat(id);
    var defaultEntrypoint = 'js/app.js';
    var defaultWidgetEntrypoint = 'js/widgets.js';
    var bundleEntrypoint = (_c = (_b = mfe.deploymentUrls) === null || _b === void 0 ? void 0 : _b.bundle.main) !== null && _c !== void 0 ? _c : "dist/".concat(defaultEntrypoint);
    var bundleWidgetEntrypoint = (_e = (_d = mfe.deploymentUrls) === null || _d === void 0 ? void 0 : _d.bundle.widgets) !== null && _e !== void 0 ? _e : "dist/".concat(defaultWidgetEntrypoint);
    var deploymentUrls = {
        web: (_a = {},
            _a[environments_1.Environment.DEV] = {
                main: (_h = (_g = (_f = mfe.deploymentUrls) === null || _f === void 0 ? void 0 : _f.web) === null || _g === void 0 ? void 0 : _g[environments_1.Environment.DEV].main) !== null && _h !== void 0 ? _h : "https://myiuapp".concat(sanitizedId, ".idss-dev.iu-aws.de/").concat(defaultEntrypoint),
                widgets: (_l = (_k = (_j = mfe.deploymentUrls) === null || _j === void 0 ? void 0 : _j.web) === null || _k === void 0 ? void 0 : _k[environments_1.Environment.DEV].widgets) !== null && _l !== void 0 ? _l : "https://myiuapp".concat(sanitizedId, ".idss-dev.iu-aws.de/").concat(defaultWidgetEntrypoint),
            },
            _a[environments_1.Environment.NONPROD] = {
                main: (_p = (_o = (_m = mfe.deploymentUrls) === null || _m === void 0 ? void 0 : _m.web) === null || _o === void 0 ? void 0 : _o[environments_1.Environment.NONPROD].main) !== null && _p !== void 0 ? _p : "https://myiuapp".concat(sanitizedId, ".idss-nonprod.iu-aws.de/").concat(defaultEntrypoint),
                widgets: (_s = (_r = (_q = mfe.deploymentUrls) === null || _q === void 0 ? void 0 : _q.web) === null || _r === void 0 ? void 0 : _r[environments_1.Environment.NONPROD].widgets) !== null && _s !== void 0 ? _s : "https://myiuapp".concat(sanitizedId, ".idss-nonprod.iu-aws.de/").concat(defaultWidgetEntrypoint),
            },
            _a[environments_1.Environment.PROD] = {
                main: (_v = (_u = (_t = mfe.deploymentUrls) === null || _t === void 0 ? void 0 : _t.web) === null || _u === void 0 ? void 0 : _u[environments_1.Environment.PROD].main) !== null && _v !== void 0 ? _v : "https://myiuapp".concat(sanitizedId, ".idss-prod.iu-aws.de/").concat(defaultEntrypoint),
                widgets: (_y = (_x = (_w = mfe.deploymentUrls) === null || _w === void 0 ? void 0 : _w.web) === null || _x === void 0 ? void 0 : _x[environments_1.Environment.PROD].widgets) !== null && _y !== void 0 ? _y : "https://myiuapp".concat(sanitizedId, ".idss-prod.iu-aws.de/").concat(defaultWidgetEntrypoint),
            },
            _a),
        bundle: {
            main: "/static/bundled-microfrontends/".concat(packageName, "@").concat(version, "/").concat(bundleEntrypoint),
            widgets: "/static/bundled-microfrontends/".concat(packageName, "@").concat(version, "/").concat(bundleWidgetEntrypoint),
        },
    };
    return __assign(__assign({}, mfe), { version: version, id: id, mountPoint: (_z = mfe.mountPoint) !== null && _z !== void 0 ? _z : microFrontends_2.MicroFrontendMountPoint.CONTENT, loader: (_0 = mfe.loader) !== null && _0 !== void 0 ? _0 : microFrontends_2.MicroFrontendLoader.CONTENT, packageName: packageName, repository: (_1 = mfe.repository) !== null && _1 !== void 0 ? _1 : "iu-group/edutech/myiu/fe.app.".concat(id), deploymentUrls: deploymentUrls });
};
exports.getMicroFrontend = getMicroFrontend;
/**
 * Get all registered micro-frontends of the given instance.
 * @param instance
 */
var getMicroFrontends = function (instance) {
    return (Array.isArray(instance.microFrontends)
        ? instance.microFrontends.map(function (name) { return [
            name,
            'latest',
        ]; })
        : Object.entries(instance.microFrontends))
        .map(function (_a) {
        var name = _a[0], version = _a[1];
        return (0, exports.getMicroFrontend)(name, version);
    })
        .filter(Boolean);
};
exports.getMicroFrontends = getMicroFrontends;
/**
 * Get all registered micro-frontends.
 */
var getAllMicroFrontends = function () {
    return Object.keys(microFrontends_1.microFrontends).map(function (microFrontendId) {
        return (0, exports.getMicroFrontend)(microFrontendId);
    });
};
exports.getAllMicroFrontends = getAllMicroFrontends;
/**
 * Check if the given instance has the given micro-frontend registered.
 * @param instance
 * @param id
 */
var hasMicroFrontend = function (instance, id) {
    return (0, exports.getMicroFrontends)(instance).some(function (microFrontend) { return microFrontend.id === id; });
};
exports.hasMicroFrontend = hasMicroFrontend;
function isInstance(instance) {
    return instance.environment !== undefined;
}
/**
 * Get all registered micro-frontends of the given instance that should be
 * mounted at the given mount point, filtered by the microfrontend's
 * `developmentOnly` property, if given a concrete instance (i.e. imbued with an environment).
 *
 * @param instance - MondrianInstance or MondrianInstanceDefinition
 * @param mountPoint - The mount point to filter by
 */
var getMicroFrontendsByMountPoint = function (instance, mountPoint) {
    return (0, exports.getMicroFrontends)(instance).filter(function (microFrontend) {
        if (isInstance(instance) &&
            instance.environment !== environments_1.Environment.DEV &&
            microFrontend.developmentOnly) {
            return false;
        }
        return microFrontend.mountPoint === mountPoint;
    });
};
exports.getMicroFrontendsByMountPoint = getMicroFrontendsByMountPoint;
/**
 * Check if the given version is a valid microfrontend version type.
 *
 * @param version - The version to check
 * @returns - Whether the version is a valid microfrontend version type
 */
function isMicroFrontendVersion(version) {
    return /^\d+.\d+.\d+/.test(version);
}
/**
 * Check if the given microfrontends definition is valid.
 *
 * This is useful to validate JSON that is used to configure MFEs
 * and their versions for instances such as bundles.
 *
 * @param microFrontendsConfig - The microfrontends definition to check
 * @returns - Whether the microfrontends definition is valid
 */
function isMicroFrontendDefinition(microFrontendsConfig) {
    return Object.entries(microFrontendsConfig).every(function (_a) {
        var key = _a[0], value = _a[1];
        return key in microFrontends_1.microFrontends && isMicroFrontendVersion(value);
    });
}
